import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';
import { Component, Input, OnInit, OnChanges, ViewContainerRef } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { EntityIdDetails, EntityType } from 'app/shared/models/entity-id-details.model';
import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { ActivityService } from 'app/shared/components/activity/activity.service';
import { ActivityDetails, Activity } from 'app/shared/components/activity/activity-details.model';
import { AddActivityComponent } from 'app/shared/components/activity/addactivity/add-activity.component';
import { WarmUpService, ApplicationTypeConstants } from 'app/services/warmup/warmup.service';
import { ConfirmationDialogComponent } from 'app/shared/components/confirmationdialog/confirmation-dialog.component';
import { ApplicationValue } from 'app/services/warmup/application-type.model';
import { EditActivityDetailsComponent } from 'app/shared/components/activity/editactivitydetails/edit-activity-details.component';
import { EditActivitySummaryComponent } from 'app/shared/components/activity/editactivitysummary/edit-activity-summary.component';

@Component({
  selector: 'activity',
  templateUrl: './activity.component.html',
  styleUrls: ['./activity.component.css']
})

export class ActivityComponent implements OnInit, OnChanges {
  @Input()
  entityIdDetails: EntityIdDetails;

  id: number;
  dialogRef: MdDialogRef<any>;
  activityDetails: ActivityDetails;
  categoryTypes: ApplicationValue[];
  subCategoryTypes: ApplicationValue[];
  categoryValue: string;
  subCategoryValue: string;

  constructor(
    public dialog: MdDialog,
    private activityService: ActivityService,
    private snackBarService: SnackBarService,
    public viewContainerRef: ViewContainerRef,
    private warmUpService: WarmUpService
  ) { }

  ngOnInit() {
    this.ngOnChanges();
  }

  ngOnChanges() {
    this.activityService.fetchActivityDetails(this.entityIdDetails.orgId).subscribe(
      response => {
        this.activityDetails = response.arrResult;
        this.updateCategoryValue();
      }
    );

    if (this.entityIdDetails && this.entityIdDetails.entityId) {
      this.id = (this.entityIdDetails.entityType === EntityType.PERSON)
        ? this.entityIdDetails.personId
        : this.entityIdDetails.orgId;
    }

    this.loadCategoryTypes(
      this.warmUpService.getApplicationValue(ApplicationTypeConstants.ORG_ACTIVITY_CATEGORY),
      'categoryType');
    this.loadCategoryTypes(
      this.warmUpService.getApplicationValue(ApplicationTypeConstants.ORG_ACTIVITY_SUB_CATEGORY),
      'subCategoryType');
  }

  loadCategoryTypes(categoryTypeValues: any, type: string) {
    if (categoryTypeValues instanceof Observable) {
      categoryTypeValues.subscribe(
        response => {
          this.warmUpService.setApplicationTypeInLS(response);
          if (type === 'categoryType') {
            this.categoryTypes = response.values;
          } else {
            this.subCategoryTypes = response.values;
          }
        }
      );
    } else {
      if (type === 'categoryType') {
        this.categoryTypes = categoryTypeValues;
      } else {
        this.subCategoryTypes = categoryTypeValues;
      }
    }
  }

  openDeleteActivityDialog(activity: Activity) {
    const config = new MdDialogConfig();
    config.disableClose = true;
    config.viewContainerRef = this.viewContainerRef;

    this.dialogRef = this.dialog.open(ConfirmationDialogComponent, config);
    this.dialogRef.componentInstance.message = 'Are you sure you want to delete this activity?';
    this.dialogRef.componentInstance.title = 'Delete Activity';
    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteActivity(activity);
      }
    });
  }

  openEditActivityDialog(activity: Activity) {
    const config = new MdDialogConfig();
    config.disableClose = true;
    config.viewContainerRef = this.viewContainerRef;

    this.dialogRef = this.dialog.open(EditActivityDetailsComponent, config)
    this.dialogRef.componentInstance.entityId = this.id;
    this.dialogRef.componentInstance.activityCategoryDetails = this.activityDetails.activityCategory;
    this.dialogRef.componentInstance.categoryTypes = this.categoryTypes;
    this.dialogRef.componentInstance.subCategoryTypes = this.subCategoryTypes;
    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.activityDetails.activityCategory = result;
        this.updateCategoryValue();
      }
    });
  }

  updateCategoryValue() {
    if (this.activityDetails) {
      const cat = this.categoryTypes.find(
        obj => obj.id === this.activityDetails.activityCategory.activityCategory);
      if (cat) {
        this.categoryValue = cat.name;
      } else {
        this.categoryValue = null;
      }
      const subCat = this.subCategoryTypes.find(
        obj => obj.id === this.activityDetails.activityCategory.activitySubCategory);
      if (subCat) {
        this.subCategoryValue = subCat.name;
      } else {
        this.subCategoryValue = null;
      }
    }
  }

  openAddActivityDialog() {
    const config = new MdDialogConfig();
    config.disableClose = true;
    config.viewContainerRef = this.viewContainerRef;
    this.dialogRef = this.dialog.open(AddActivityComponent, config);
    this.dialogRef.componentInstance.entityId = this.id;
    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.activityDetails.activities.push(result);
      }
    });
  }

  deleteActivity(activity: Activity): void {
    activity.organisationId = this.id;
    this.activityService.deleteActivity(activity)
      .subscribe(response => {
        this.activityDetails.activities.splice(this.activityDetails.activities.indexOf(activity), 1);
        this.callSnackBarService(response);
      }, err => {
        this.callSnackBarService(err);
      }
      );
  }

  openEditActivitySummaryDialog() {
    const config = new MdDialogConfig();
    config.disableClose = true;
    config.viewContainerRef = this.viewContainerRef;
    this.dialogRef = this.dialog.open(EditActivitySummaryComponent, config);
    this.dialogRef.componentInstance.entityId = this.id;
    this.dialogRef.componentInstance.summary = this.activityDetails.activitySummary;
    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.activityDetails.activitySummary = result;
      }
    });
  }

  callSnackBarService(response: any) {
    this.snackBarService
      .showStatus(response,
      MessageService.DELETE_ACTIVITY_SUCCESS,
      MessageService.ACTIVITY_FAILURE);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/activity/activity.component.ts